// Mock data for XMC Algo landing page
export const mockData = {
  // Logo
  logoUrl: 'https://customer-assets.emergentagent.com/job_algo-trading-hub-30/artifacts/05fj5jtf_Screenshot%202026-04-17%20at%2012.59.20%E2%80%AFpm.png',
  
  // PDF Guide
  pdfUrl: 'https://customer-assets.emergentagent.com/job_algo-trading-hub-30/artifacts/c86nxwph_xmc_algo_quick_start.pdf',
  
  // Stripe Payment Links (LIVE MODE)
  stripeLinks: {
    weekly: 'https://buy.stripe.com/aFa6oGdqpbPP4qA5ac48002', // $14/week
    monthly: 'https://buy.stripe.com/28EdR82LL077g9igSU48001', // $49/month
    lifetime: 'https://buy.stripe.com/5kQfZg721dXXcX6eKM48000', // $399 one-time
  }
};
